import { MessageCircle } from "lucide-react";
import { SITE } from "../../lib/config";

export default function WhatsAppButton() {
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Hi Chennai Packs, I'd like to know more about your packaging products."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="hidden sm:flex fixed bottom-6 right-6 z-50 items-center gap-2 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3.5 shadow-xl shadow-[#25D366]/30 hover:scale-105 active:scale-95 transition-transform"
    >
      <MessageCircle size={22} className="fill-white" />
      <span className="hidden sm:inline font-semibold text-sm">WhatsApp</span>
    </a>
  );
}
